var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShifter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 5.33333,
    height: 5.33333,
    rx: 1,
    fill: "#1271A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66797,
    y: 2,
    width: 5.33333,
    height: 5.33333,
    rx: 1,
    fill: "#1271A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66797,
    y: 8.6665,
    width: 5.33333,
    height: 5.33333,
    rx: 1,
    fill: "#1271A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 12.9995C7.33301 13.5518 6.88529 13.9995 6.33301 13.9995H3C2.44772 13.9995 2 13.5518 2 12.9995V9.6665C2 9.11422 2.44772 8.6665 3 8.6665H6.33301C6.88529 8.6665 7.33301 9.11422 7.33301 9.6665V12.9995ZM4.06641 9.73291C3.51412 9.73291 3.06641 10.1806 3.06641 10.7329V11.9331C3.06641 12.4854 3.51412 12.9331 4.06641 12.9331H5.2666C5.81889 12.9331 6.2666 12.4854 6.2666 11.9331V10.7329C6.2666 10.1806 5.81889 9.73291 5.2666 9.73291H4.06641Z",
    fill: "#1271A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShifter);
export default __webpack_public_path__ + "static/media/shifter.c41b34b2c7a07a6f93972eb89d9f62ee.svg";
export { ForwardRef as ReactComponent };